// NEW: UI_REVAMP
import { Flex } from '@chakra-ui/react';
import React from 'react';
import Prize from '../components/prize/Prize';

const PrizeScreen = () => {
	return (
		<Flex w='full' alignItems='start'>
			<Prize />
		</Flex>
	);
};

export default PrizeScreen;
